/**
 * Condições responsáveis por ativar e desativar os inputs do formulário do modal.
 */

export function desabledCustomerCondition() {
	return !this.$mx_hasValue(this.form.sponsor)
}

export function desabledStageCondition() {
	return (
		this.funnelStageOptions.length == 0 ||
		(this.customerChangeOption &&
			(!this.$mx_hasValue(this.form.sponsor) || !this.$mx_hasValue(this.customerDeal))) ||
		!this.$mx_hasValue(this.getDealId)
	)
}

export function desabledSatusCondition() {
	return (
		this.funnelStageOptions.length == 0 ||
		this.funnelStageStatusOptions.length == 0 ||
		!this.$mx_hasValue(this.form.funnel_stage_id) ||
		(this.customerChangeOption &&
			(!this.$mx_hasValue(this.form.sponsor) ||
				!this.$mx_hasValue(this.customerDeal) ||
				!this.$mx_hasValue(this.getDealId)))
	)
}

export function desabledHistoricalCondition() {
	return (
		!this.isChangedStateAndSate ||
		(this.customerChangeOption && !this.$mx_hasValue(this.getDealId)) ||
		this.historicalTypesOptions.length == 0
	)
}

/**
 * Condições responsáveis por analisar se os dados foram preenchidos.
 */

export function allowFill() {
	return this.$mx_hasValue(parseInt(this.form.allow_fill))
}

export function hasLoading() {
	return (
		this.loader.customerLoad ||
		this.loader.stageLoad ||
		this.loader.stageStatusLoad ||
		this.loader.historicalTypesLoad
	)
}

export function hasCustomersAndSelectedStage() {
	return (
		this.$mx_hasValue(this.form.customer_id) &&
		this.funnelStageOptions.length > 0 &&
		this.$mx_hasValue(this.form.funnel_stage_id) &&
		this.isChangedStateAndSate
	)
}

export function hasStatusListAndIsSelected() {
	return (
		this.funnelStageStatusOptions.length > 0 &&
		this.$mx_hasValue(this.form.funnel_stage_status_id)
	)
}

export function notHasStatusListAndIsNotSelected() {
	return (
		this.funnelStageStatusOptions.length == 0 &&
		!this.$mx_hasValue(this.form.funnel_stage_status_id)
	)
}

export function hasHistoricalNote() {
	return this.$mx_hasValue(this.historical.message) && this.$mx_hasValue(this.historical.type)
}

export function notHasHistoricalNote() {
	return !this.$mx_hasValue(this.historical.message) && !this.$mx_hasValue(this.historical.type)
}

export function canSubmit() {
	return (
		this.allowFill &&
		!this.hasLoading &&
		this.hasCustomersAndSelectedStage &&
		(this.hasStatusListAndIsSelected || this.notHasStatusListAndIsNotSelected) &&
		(this.hasHistoricalNote || this.notHasHistoricalNote)
	)
}
